var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"actions"},[_c('Spacer'),_vm._t("default",[_c('StandardButton')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }